import { Injectable } from '@angular/core';
import { format, formatDateInt, formatDateTimeInternal } from '@core/_utils/date.utils';
import { decodeUtf8, returnEmpty } from '@core/_utils/tools.utils';

@Injectable()
export class AddFileService {
    constructor(
    ) { 
    }

    public clear() {
    }
    
    public getDocumentList() {
        let wDocumentList = {
            DocumentList: {
                Document: {
                    Docid: 'Docid',
                },
            },
        };
        return wDocumentList;
    }

    public getDocument(aFileName, aFileSize, aBaseRoot, aStoragePath) {
        let wDocument = {
            CreationDate: formatDateTimeInternal(new Date()),
            Name: aFileName,
            Extension: '',
            Size: aFileSize,
            Crc: '',
            Docid: 'Docid',
            BaseRoot: aBaseRoot,
            StoragePath: decodeUtf8(aStoragePath),
            Owner: 'User',
            Origin: 'DocumalisV6',
        };
        return wDocument;
    }

    public getRequestSend(aData, abskType, abskName) {
        let wRequest = '';
        let wAction = '';
        let wDateLim = '';
        let wRequestSend: any;
        let wInfosMail = new Object();
        if (abskType === 'btMail') {
            wAction = 'mailinsert';
            if (aData.mailLimit === true) {
                wDateLim = format(aData.dateLimit);
            }
            wInfosMail = {
                mailAction: aData.mailAction,
                status: aData.status,
                SrcBasketName: abskName,
                dstBasketName: abskName,
                msgId: '',
                mailLimit: wDateLim,
                mailUrg: aData.mailUrgent,
                mailConf: aData.mailConf,
            };
        } else {
            wAction = 'insert';
            wInfosMail = {
                SrcBasketName: abskName,
                dstBasketName: abskName,
            };
        }
        wRequest = this.formatRequestUpdate(wAction, wInfosMail);

        wRequestSend = {
            Request: wRequest,
        };        
        return wRequestSend;
    }

    public getPreProcess(aPreProcessName, aParameterList) {
        let wPreProcess = {
            UsePreProcess: 'true',
            PreProcessName: aPreProcessName,
            ParameterList: this.prepareParamList(aParameterList),
        };
        return wPreProcess;
    }

    private formatRequestUpdate(aAction, aInfoMail) {
        let wRequest;
        let wBaseInfos;
        let wExtended;
        wBaseInfos = {
            Docid: 'Docid',
            DstBasketName: aInfoMail.dstBasketName,
            User: 'User',
        };

        if (aAction === 'mailinsert') {
            wExtended = {
                DocStatus: aInfoMail.status,
                Wkfid: aInfoMail.msgId,
                MailAction: aInfoMail.mailAction,
                MailLimit: aInfoMail.mailLimit,
                MailUrgent: aInfoMail.mailUrg,
                MailConfidential: aInfoMail.mailConf,
            };
            wRequest = this.formatParamList(wBaseInfos, wExtended);
        } else {
            wRequest = this.formatParamList(wBaseInfos);
        }
        return wRequest;
    }

    private formatParamList(wBaseInfos, wExtended = {}) {
        return {
            Command: 'Insert',
            ParamList: {
                ...wBaseInfos,
                ...wExtended,
            },
        };
    }

    public prepareVarList(aData, aEditorService) {
        let Variable: any;
        let VariableList = new Array();
        let wValue;
        aData.map((item) => {
            if (item.type !== 'separator') {
                if (item.type === 'Date' || item.type === 'DateTime') {
                    wValue = this.getDate(item);
                } else {
                    wValue = aEditorService.getValueFromType(item, true);
                }
                Variable = new Object();
                Variable.Name = item.name;
                Variable.Type = item.type;
                Variable.Need = item.Required;
                Variable.Value = wValue;
                VariableList.push({ Variable: Variable });
            }
        });

        let wVariable = {
            VariableList: VariableList,
        };
        return JSON.stringify(wVariable);
    }

    public setInfosMail(aData, aTranslate) {
        return {
            dateLimit: aData.dateLimit,
            mailAction: aData.mailAction,
            mailConf: aData.mailConf,
            mailLimit: aData.mailLimit,
            mailUrgent: aData.mailUrgent,
            status: aData.status,
            mailActionLabel: aTranslate.instant('Mail_'+ aData.value),
            mailDelay: aData.mailDelay,
        };
    }

    public getEnterVariable(abskVariableList) {
        let wRes = false;
        for (const item of abskVariableList) {
            if (item.system === 'false' && item.type !== 'separator') {
                wRes = true;
                break;
            }
        }
        return wRes;
    }


    public updateItem(aItem, aEditorService) {
        let wValue = '';
        if (aItem.type !== 'separator') {
            if (aItem.type === 'Date' || aItem.type === 'DateTime') {
                wValue = this.getDate(aItem);
            } else {
                wValue = aEditorService.getValueFromType(aItem, false);
            }
            aItem.DefaultValue = wValue;
            if (aItem.Editable === true) {
                if (aItem.value.displayValue === undefined) {
                    aItem.valueCombo = aItem.value;
                } else {
                    aItem.valueCombo = aItem.value.retCode;
                }
            }
        }
    }

    public getDate(item) {
        let wValue = '';
        wValue = returnEmpty(item.value);
        if (wValue !== '') {
            wValue = formatDateInt(new Date(wValue), false); // ok pour requete
        }
        return wValue;
    }

    private prepareParamList(aParameterList) {
        let Parameter: any;
        let ParameterList = new Array();
        aParameterList.map((item) => {
            Parameter = new Object();
            Parameter.Name = item.Name;
            Parameter.Value = item.Value;
            ParameterList.push({ Parameter: Parameter });
        });
        return ParameterList;
    }
}

